import SdkTrack from "@/Fwk/Kit/SdkTrack";

//手机号输入场景枚举
export enum PhoneInputScene {
    SignUp = 1,  //注册场景
    Login = 2,  //登录场景
    PhoneVerify = 3,  //手机号验证场景
    ForgotPassword = 4,  //找回密码场景
}
//验证码接收发送场景
export enum CodeSendScene {
    SignUp = 1,  //注册场景
    ForgotPassword = 2,  //忘记密码场景
}
//密码输入场景
export enum PasswordInputScene {
    SignUp = 1,  //注册场景
    Login = 2,  //登录场景
    ForgotPassword = 3,  //找回密码场景
}
//发起注册场景
export enum SignUpScene {
    DidNotRecharge = 1,  //游客未充值
    HasRecharge = 2,  //游客已充值
}
//账号登录场景
export enum LoginScene {
    Welcome = 1,  //欢迎页进入
    SignUp = 2,  //注册页点击
    TokenExpired = 3,  //token失效
    Redeem = 4,  //兑换页跳转
    visitorRecharge = 5,  //游客支付
}
//游客充值号码校验结果场景
export enum CheckVisitorPhoneResultScene {
    Registered = 1,  //已注册
    Unregistered = 2,  //未注册
}

export default class AuthTrack {
    static tag = ['AuthTrack'];
    /**账号注册相关start */
    //账号注册界面展示时
    static showSignUp() {
        SdkTrack.track513Commit('show_sign_up')
    }
    //手机号输入完成时
    static inputPhone(scene: PhoneInputScene) {
        SdkTrack.track513Commit('enter_phone_number', scene+'')
    }
    //点击发送验证码按钮
    static clickSendCode(scene: CodeSendScene) {
        SdkTrack.track513Commit('click_code_button',''+scene)
    }
    //验证码接收请求发送时
    static sendCode(scene: CodeSendScene) {
        SdkTrack.track513Commit('code_request',''+scene)
    }
    //验证码接收请求成功时
    static sendCodeSuccess(scene: CodeSendScene) {
        SdkTrack.track513Commit('code_request_sus',''+scene)
    }
    //验证码接收请求失败时
    static sendCodeFail(scene: CodeSendScene) {
        SdkTrack.track513Commit('code_request_fail',''+scene)
    }
    //输入验证码，检验成功时
    static inputCodeSuccess(scene: CodeSendScene) {
        SdkTrack.track513Commit('enter_code_sus',''+scene)
    }
    //输入验证码，检验失败时
    static inputCodeFail(scene: CodeSendScene) {
        SdkTrack.track513Commit('enter_code_fail',''+scene)
    }
    //密码设置输入完成时
    static inputPassword(scene: PasswordInputScene) {
        SdkTrack.track513Commit('enter_password', scene+'')
    }
    //密码输入失败时
    static inputPasswordFail(scene: PasswordInputScene) {
        SdkTrack.track513Commit('password_fail', scene+'')
    }
    //密码输入正确时
    static inputPasswordSuccess(scene: PasswordInputScene) {
        SdkTrack.track513Commit('password_sus', scene+'')
    }
    //密码二次输入完成时
    static inputPasswordAgain() {
        SdkTrack.track513Commit('enter_password_again')
    }
    //密码二次输入失败时
    static inputPasswordAgainFail() {
        SdkTrack.track513Commit('password_again_fail')
    }
    //密码二次输入正确时
    static inputPasswordAgainSuccess() {
        SdkTrack.track513Commit('password_again_sus')
    }
    //点击注册按钮,注册成功时
    static clickSignUpSuccess(scene: SignUpScene) {
        SdkTrack.track513Commit('click_sign_button', scene+'')
    }
    //游客模式登录，点击play as guest按钮时
    static clickPlayAsGuest() {
        SdkTrack.track513Commit('click_guest_button')
    }
    //已有账户登录，点击Existing account按钮时
    static clickExistingAccount() {
        SdkTrack.track513Commit('click_exist_button')
    }
    //已注册弹窗展示时
    static showRegistered() {
        SdkTrack.track513Commit('show_registered_pag')
    }
    //点击按钮Go to login前往登录时
    static clickGoToLogin() {
        SdkTrack.track513Commit('click_go_login')
    }
    /**账号注册相关end */

    /**账号登录相关start */
    //账号登录界面展示时
    static showLogin(scene: LoginScene) {
        SdkTrack.track513Commit('show_login', scene+'')
    }
    //点击登录按钮，成功登录账户时
    static clickLoginSuccess() {
        SdkTrack.track513Commit('click_login_button')
    }
    //创建账户，点击Create account按钮时
    static clickCreateAccount() {
        SdkTrack.track513Commit('click_create_button')
    }
    //忘记密码，点击Forgot password按钮时
    static clickForgotPassword() {
        SdkTrack.track513Commit('click_forgot_button')
    }
    /**账号登录相关end */

    /**找回密码相关start */
    //找回密码界面展示时
    static showForgotPassword(count:number) {
        SdkTrack.track513Commit('show_find_password', count + '');
    }
    //立刻登录
    static clickLoginNow() {
        SdkTrack.track513Commit('click_login_now')
    }
    /**找回密码相关end */

    /**游客充值号码验证相关start */
    //游客模式号码检验弹窗展示时
    static showPhoneVerify() {
        SdkTrack.track513Commit('show_guest_phone')
    }
    //点击submit按钮时
    static clickSubmit() {
        SdkTrack.track513Commit('click_submit')
    }
    //号码校验请求加载时
    static sendPhoneVerify() {
        SdkTrack.track513Commit('phone_request')
    }
    //号码校验结果返回时
    static sendPhoneVerifyResult(scene: CheckVisitorPhoneResultScene) {
        SdkTrack.track513Commit('request_result', scene+'')
    }
    /**游客充值号码验证相关end */

}